import axios from 'axios'

const checkAuth = (url) => {
    axios(url)
        .then(resp => {

        })
        .catch(async error => {
            alert(error.response.data)
            localStorage.clear()
            if (url == "/api/auth/checkAuth") {
                window.location = '/'
            } else if (url == "/api/authJuridico/checkAuth") {
                window.location = '/juridico'
            } else {
                window.location = '/etica'
            }
        }
        )
}

export default checkAuth